export default async () => {
  const carouselWraps = document.querySelectorAll("[data-component=carousel]");

  if (carouselWraps.length) {
    const { default: FixedWidthCarousel } = await import(
      "./FixedWidthCarousel"
    );

    carouselWraps.forEach((carouselWrap) => {
      const carousel = carouselWrap.querySelector(".ag-carousel");

      if (!carousel || !(carousel instanceof HTMLElement)) return;

      const { slideWidth } = carousel.dataset;

      new FixedWidthCarousel({
        selector: carousel,
        sigmoidMax: 120,
        ...(slideWidth && { slideWidth }),
      });
    });
  }
};
